import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export default class ProgramVariant extends Model {
  resource() {
    return 'variants'
  }
}
